import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ContentPageId } from '@shared/models/content-page-ids';
import * as fromRootStore from '@store/index';
import { LinkComponent } from '@vg-constellation/angular-16/link';

import { PageComponent } from '../page/page.component';

@Component({
  selector: 'app-phone-blockquote',
  templateUrl: './phone-blockquote.component.html',
  styleUrls: ['./phone-blockquote.component.scss'],
  standalone: true,
  imports: [LinkComponent, AsyncPipe],
})
export class PhoneBlockquoteComponent extends PageComponent {
  constructor(globalStore: Store<fromRootStore.State>) {
    super(ContentPageId.shared, globalStore);
  }
}
